/* Xperts4x4 – sélecteur véhicule mémorisé (localStorage "x4x_vehicle"). */
(function () {
  if (customElements.get('x4x-vehicle-bar')) return;
  var KEY = 'x4x_vehicle';
  function load() { try { return JSON.parse(localStorage.getItem(KEY)); } catch (e) { return null; } }
  function save(v) { try { localStorage.setItem(KEY, JSON.stringify(v)); } catch (e) {} }
  function clear() { try { localStorage.removeItem(KEY); } catch (e) {} }
  function usable(u) { return u && u !== '#' && u.indexOf('/') === 0; }

  customElements.define('x4x-vehicle-bar', class extends HTMLElement {
    connectedCallback() {
      try { this.tree = JSON.parse(this.querySelector('[data-tree]').textContent); } catch (e) { return; }
      this.sel = [1, 2, 3].map(function (n) { return this.querySelector('[data-level="' + n + '"]'); }, this);
      this.go = this.querySelector('[data-go]');
      this.form = this.querySelector('[data-form]');
      this.saved = this.querySelector('[data-saved]');
      this.fill(0, this.tree);
      this.sel.forEach(function (s, i) { s.addEventListener('change', this.onChange.bind(this, i)); }, this);
      this.form.addEventListener('submit', this.onGo.bind(this));
      var toggle = this.querySelector('[data-toggle]');
      toggle.addEventListener('click', function () {
        var open = this.classList.toggle('is-open');
        toggle.setAttribute('aria-expanded', open);
      }.bind(this));
      this.querySelector('[data-change]').addEventListener('click', function () { this.showForm(); this.classList.add('is-open'); toggle.setAttribute('aria-expanded', true); }.bind(this));
      this.querySelector('[data-clear]').addEventListener('click', function () { clear(); this.showForm(); }.bind(this));
      var v = load();
      if (v && usable(v.url) && v.label) this.showSaved(v); else this.showForm();
    }
    fill(i, items) {
      var s = this.sel[i];
      s.length = 1;
      (items || []).forEach(function (it, k) { s.add(new Option(it.t, k)); });
      s.disabled = !items || !items.length;
      s.hidden = i > 0 && s.disabled && !!this.sel[i - 1].value;
      for (var j = i + 1; j < 3; j++) { this.sel[j].length = 1; this.sel[j].disabled = true; this.sel[j].hidden = false; }
    }
    path() {
      var node = null, items = this.tree, out = [];
      for (var i = 0; i < 3; i++) {
        var v = this.sel[i].value;
        if (v === '' || !items) break;
        node = items[+v]; out.push(node); items = node.c;
      }
      return out;
    }
    onChange(i) {
      var p = this.path();
      var last = p[p.length - 1];
      if (i < 2) this.fill(i + 1, p.length === i + 1 && last ? last.c : null);
      var done = last && (p.length === 3 || !(last.c && last.c.length));
      this.go.disabled = !(done && usable(last.u));
    }
    onGo(e) {
      e.preventDefault();
      var p = this.path(), last = p[p.length - 1];
      if (!last || !usable(last.u)) return;
      save({ label: p.map(function (n) { return n.t; }).join(' '), url: last.u });
      window.location.href = last.u;
    }
    showSaved(v) {
      this.saved.querySelector('[data-saved-name]').textContent = v.label;
      this.saved.querySelector('[data-saved-link]').href = v.url;
      this.saved.hidden = false; this.form.hidden = true;
    }
    showForm() { this.saved.hidden = true; this.form.hidden = false; }
  });
})();
